import React, {Component, useState} from 'react';

import {
    TextArea, Button
} from "carbon-components-react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

export default class extends Component {

    state = {
        form: {
            modal_comentario: false,
            matricula: "",
            nome: "",
            id_comentario: "",
            comentario: ""
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                modal_comentario: form.modal_comentario,
                matricula: form.matricula,
                nome: form.nome,
                id_comentario: form.id_comentario,
                comentario: form.comentario
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleCloseModal = async (e) => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_comentario: false}
        }));
        this.props.onCloseModal(this.state.form);
    }


    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    render() {

        return (
            <>
                <Dialog open={this.state.form.modal_comentario} onClose={(e) => this.handleCloseModal(e)}
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}>
                    <DialogTitle id="form-dialog-title"><span
                        style={{color: "#000"}}>{this.state.form.matricula} - {this.state.form.nome}</span>
                    </DialogTitle>
                    <DialogContent>
                        <TextArea
                            id="comments"
                            name="comentario"
                            enableCounter={true}
                            labelText={"Comentário"}
                            maxCount={255}
                            rows={4}
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.form.comentario}
                        />
                    </DialogContent>
                    <DialogActions style={{marginRight: "16px"}}>
                            <Button kind="secondary" onClick={(e) => this.handleCloseModal(e)} isExpressive>
                                Cancelar
                            </Button>
                            <Button style={{marginLeft:"0px"}} kind="primary" onClick={(e) => this.handleSubmit(e)} isExpressive>
                                Salvar
                            </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
